const React = require('react');

class Ingress extends React.Component {
    render() {
        return <p>{this.props.text}</p>
    }
}

module.exports = Ingress;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/ingress/Component/index.jsx